import {audioCorrect, audioIncorrect} from "./audio";
import {lastQuestion, nextQuestion} from "./question";
import {ending} from "./ending";
import {apiAnswer} from "./api";

const answersFrame = document.querySelector('#questions .answers');
const answers = document.querySelectorAll('#questions .answers .answer');
const nextQuestionButton = document.querySelector('#questions button');
export let score = 0;

answers.forEach(answer => {
        answer.addEventListener('click', () => {
            if (answersFrame.classList.contains('clicked')) return;
            answersFrame.classList.add('clicked');
            answer.classList.add('selected');

            if (answer.dataset.correct === '1') {
                audioCorrect();
                score++;
                apiAnswer(true);
            } else {
                audioIncorrect();
                apiAnswer(false);
            }

            nextQuestionButton.disabled = false;
        })
    }
)

nextQuestionButton.addEventListener('click', () => {
    nextQuestionButton.disabled = true;

    if (lastQuestion) {
        ending();
    } else {
        answersFrame.classList.remove('clicked');
        nextQuestion();
        answers.forEach(answer => {
            answer.classList.remove('selected');
        })
    }
})